<form #form="ngForm">
    <div class="transport-details">
        <app-checkbox #customerCheckbox name="customer-transport-active" [caption]="'Use your FTP solution'" [ngModel]="!!customerTransport()" (ngModelChange)="customerActiveChanged($event)" [disabled]="disabled()"></app-checkbox>
        @if (!!customerTransport()) {
            <app-ftp-transport-viewer name="customer-transport" [ngModel]="customerTransport()" (ngModelChange)="updateTransport($event)" [disabled]="disabled()"></app-ftp-transport-viewer>
        }
    </div>

    <div class="transport-details">
        <app-checkbox #partnerCheckbox name="partner-transport-active" [caption]="'Use your partners FTP solution'" [ngModel]="!!partnerTransport()" (ngModelChange)="partnerActiveChanged($event)" [disabled]="disabled()"></app-checkbox>
        @if (!!partnerTransport()) {
            <app-ftp-transport-viewer name="partner-transport" [ngModel]="partnerTransport()" (ngModelChange)="updateTransport($event)" [disabled]="disabled()"></app-ftp-transport-viewer>
        }
    </div>
</form>